// store.js

import { configureStore } from "@reduxjs/toolkit";
import impactReducer from "./impactSlice";
import campaignReducer from "./CampaignSlice";
import causesReducer from "./causesSlice";
import userReducer from "./userSlice";
import sidebarReducer from "./sidebarSlice";

const store = configureStore({
  reducer: {
    impacts: impactReducer,
    campaign: campaignReducer,
    causes: causesReducer,
    user: userReducer,
    sidebar: sidebarReducer,
  },
});

export default store;
